<template>
    <div v-if="text">
        <alert class="bg-white">
            <template #icon>
                <svg class="w-4 h-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
            </template>
            <template #text>
                <div v-if="hasDefaultSlot" class="text-green-800"><slot></slot></div>
                <p v-if="!hasDefaultSlot" class="text-green-800">{{ text }}</p>
            </template>
            <template #link>
                <slot name="link"></slot>
            </template>
        </alert>
    </div>
</template>

<script>
import Alert from "./Alert"

export default {
    components: { Alert },

    props: ["alert"],

    computed: {
        hasDefaultSlot() {
            return !!this.$slots.default
        },
        text() {
            if (!this.alert) return null
            return this.alert.success
        },
    },
}
</script>
